import { gatsbyImageSchema } from '@ecomm/contentful-schemas'
import { jsonSchema } from '@ecomm/micro-copy'
import {
  appFeaturesCarouselAssetsSchema,
  expertReviewsAdditionalSchema,
  expertsReviewsAssetSchema
} from '@ecomm/scout'
import { quoteWizardSchema } from '@ecomm/shared-components/data/QuizBanner/quoteWizardSchema'
import { affirmBannerSchema } from '@ecomm/shared-components/lib/AffirmBanner/schema'
import type { IconTypes } from '@ecomm/shared-icons'
import { experimentTemplateSchema } from '@ecomm/shared-ninetailed'
import { type TypeOf, z } from '@simplisafe/ewok'

const ninetailedFeatureFlagDraftSchema = z.object({
  id: z.string(),
  title: z.string(),
  json: z.object({
    id: z.string(),
    tag: z.string()
  })
})
const experimentSchema = experimentTemplateSchema.extend({
  id: z.string(),
  variants: z.array(ninetailedFeatureFlagDraftSchema),
  audience: z
    .object({
      id: z.string(),
      name: z.string()
    })
    .nullish()
})
export const ninetailedFeatureFlagSchema =
  ninetailedFeatureFlagDraftSchema.extend({
    nt_experiences: z.array(experimentSchema).default([])
  })

export const landerBelowTheFoldSchema = z.object({
  contentfulAffirmBanner: affirmBannerSchema,
  videoButtonAsset: gatsbyImageSchema,
  cameraBannerAsset: gatsbyImageSchema,
  expertReviewsAssets: expertsReviewsAssetSchema,
  expertReviewsAdditionalAssets: expertsReviewsAssetSchema.nullish(),
  appFeaturesCarouselAssets: appFeaturesCarouselAssetsSchema,
  guaranteeAsset: gatsbyImageSchema,
  quoteWizardAsset: gatsbyImageSchema,
  quoteWizardAssetOdmon: gatsbyImageSchema.nullish(),
  quoteWizard: quoteWizardSchema,
  guaranteeCopy: jsonSchema.extend({ contentful_id: z.string() }),
  confidenceBar: z
    .array(
      z.object({
        icon: z.custom<IconTypes>(),
        headline: z.string()
      })
    )
    .readonly(),
  videoBanner: jsonSchema.extend({ contentful_id: z.string() }).nullish(),
  videoBannerExperiment: jsonSchema
    .extend({ contentful_id: z.string() })
    .nullish(),
  expertReviews: jsonSchema.extend({ contentful_id: z.string() }),
  expertReviewsAdditional: expertReviewsAdditionalSchema.nullish(),
  expertSectionAsset: gatsbyImageSchema,
  hideVideoAndAffirmBannerExperiment: ninetailedFeatureFlagSchema.nullish()
})

export type LanderBelowTheFoldSchema = TypeOf<typeof landerBelowTheFoldSchema>
